<template>
  <div class="cont">

  </div>
</template>

<script>
  export default {
    data() {
      return {
        code: "",
        path: ''
      }
    },
    computed: {},
    created() {
      this.code = this.$tools.getQueryString('code')
      this.path = this.$tools.getQueryString('path')

      if (this.code) {
        this.weixinLogin()
      }else {
        this.$router.push({
          path: '/login'
        })
      }
    },
    methods: {
      // 微信登录
      weixinLogin() {
        // const loading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // });
        this.$api.apiContent.dandian({
          emofUserTokenSafer: this.code
        }).then(res => {
          // loading.close();
          this.$store.state.user = res.data
          this.$store.state.emofUserTokenSafer = res.data.emofUserTokenSafer
          this.$router.push({
            path: this.path
          })
        }).catch(res => {
          // loading.close();
          this.$messageError(res.msg);
          setTimeout(function () {
            this.$router.push({
              path: '/login'
            })
          },1500)
        })
      },
    },
    components: {},
    watch: {}
  }
</script>

<style scoped lang="scss">
 .cont{
   position: fixed;
   top: 0;
   right: 0;
   left: 0;
   bottom: 0;
   background: #fff;
 }
</style>